import fetchApi from "../utilities/fetch/httpService";
import apiUrls from "../utilities/consts/apiUrls";

export const getPostCategories = () =>
  fetchApi({
    url: apiUrls.news.post_categories,
    method: "get",
  });

export const getPostTags = () =>
  fetchApi({
    url: apiUrls.news.post_tags,
    method: "get",
  });

export const getPosts = (category, tag, page) =>
  fetchApi({
    url: (category === 0 && tag === 0
      ? apiUrls.news.posts_list_all
      : category
      ? apiUrls.news.posts_list_by_category
      : tag
      ? apiUrls.news.posts_list_by_tag
      : apiUrls.news.posts_list_all
    )
      .replace(
        category === 0 ? "category=$category" : "$category",
        category === 0 ? "" : category
      )
      .replace(tag === 0 ? "tag=$tag" : "$tag", tag === 0 ? "" : tag)
      .replace("$page", page),
    method: "get",
  });

export const getPostDetail = (postId) =>
  fetchApi({
    url: apiUrls.news.post_by_id.replace("$id", postId),
    method: "get",
  });
